import { useEffect, useMemo, useCallback } from "react";
import useWeeklyData from "./hooks/useWeeklyData";
import useWeeklyUI from "./hooks/useWeeklyUI";
import useWeeklyFiltering from "./hooks/useWeeklyFiltering";
import useWeeklySlotStatus from "./hooks/useWeeklySlotStatus";
import useBasketManager from "../FinalizePage/hooks/useBasketManager";

export default function useWeeklyGrid(courtName: string) {
  const uiState = useWeeklyUI();
  const { basket, getBasket } = useBasketManager();

  useEffect(() => {
    getBasket();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const exercisesInBasket = useMemo(() => {
    return basket
      .filter((item) => item.ticketAccess && item.ticketAccess.length > 0)
      .flatMap((item) => item.ticketAccess.map((access) => parseInt(access.exerciseIds)))
      .filter((id) => !isNaN(id));
  }, [basket]);

  const { weeklyGridData, loading, refetch } = useWeeklyData({
    startDate: uiState.startDate,
    isMobile: uiState.isMobile,
    courtName,
  });

  const slotStatus = useWeeklySlotStatus({
    exercisesInBasket,
  });

  const filtering = useWeeklyFiltering({
    weeklyGridData,
    startDate: uiState.startDate,
    isMobile: uiState.isMobile,
  });

  const handleTicketAdded = useCallback(
    (exerciseId: number) => {
      setTimeout(() => {
        getBasket();
      }, 100);
    },
    [getBasket]
  );

  const handleCloseReservationModalWithReset = useCallback(() => {
    uiState.handleCloseReservationModal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    weeklyGridData: filtering.weeklyGridData,
    loading,
    startDate: uiState.startDate,
    setStartDate: uiState.setStartDate,
    reservationModal: uiState.reservationModal,
    isMobile: uiState.isMobile,
    exercisesInBasket,
    // Data refresh
    refetchWeeklyData: refetch,
    // Filtering
    uniqueHours: filtering.uniqueHours,
    findSlot: filtering.findSlot,
    // Slot status
    getSlotStatus: slotStatus.getSlotStatus,
    // Handlers
    handleSlotClick: uiState.handleSlotClick,
    handleCloseReservationModal: handleCloseReservationModalWithReset,
    handlePreviousPeriod: uiState.handlePreviousPeriod,
    handleNextPeriod: uiState.handleNextPeriod,
    handleTicketAdded,
  };
}

